import { apiCall } from "./Interceptor";

const NOTIFICATIONS_ALL = "/notifications";
const NOTIFICATION_MARK_READ_ALL = "/notifications/read/all";

const getAllNotifications = async () => {
    const response = await apiCall.get(NOTIFICATIONS_ALL);
    return response;
}
const markAllNotificationsRead = async () => {
    const response = await apiCall.put(NOTIFICATION_MARK_READ_ALL);
    return response;
}
export default {
    getAllNotifications,
    markAllNotificationsRead,
};
